import * as React from "react";
import FormGroup from "../../../hiberUiKit/src/molecules/FormGroup/FormGroup";
import DropDown from "../../../hiberUiKit/src/molecules/DropDown/DropDown";
import {LabelableProps} from "../../common/props/LabelableProps";
import {FormGroupProps} from "../../common/props/FormGroupProps";
import {PlaceholderProps} from "../../common/props/PlaceholderProps";
import {option} from "ts-option";
import QuoteEmailStyle from "../../../model/partnerBrand/QuoteEmailStyle";
import {RootState} from "../../../store/reducer/root/RootState";
import {connect} from "react-redux";

interface IReduxProps {
	/**
	 * Quote email templates styles
	 */
	quoteEmailStyles: QuoteEmailStyle[]
}

type Props = IReduxProps & FormGroupProps<string> & PlaceholderProps & LabelableProps

class QuoteEmailStyleFormGroup extends React.Component<Props, {}> {
	render() {
		return (
			<FormGroup label={this.props.label} error={this.props.field.firstError().orNull}>
				<DropDown placeholder={this.props.placeholder}
						  items={this.props.quoteEmailStyles}
						  itemToId={(item: QuoteEmailStyle) => item.suffix}
						  itemToLabel={(item: QuoteEmailStyle) => item.name}
						  onSelect={(item: QuoteEmailStyle) => this.props.onChange(
							  this.props.field.updateValue(option(item.suffix)))}
						  selectedItemId={this.props.field.getOptionalValue().orNull}/>
			</FormGroup>
		)
	}
}

function mapStateToProps(state: RootState) {
	return ({
		quoteEmailStyles: state.partnerBrand.quoteEmailStyles.getOrElse([])
	})
}

export default connect(mapStateToProps)(QuoteEmailStyleFormGroup)